export default "__VITE_ASSET__DY7WzN6f__"